import { ConnectedRouter } from 'connected-react-router';
import React, { useEffect } from 'react';
import {Provider as ReduxProvider, useSelector} from 'react-redux';
import ResetableUrqlProvider from './components/utils/resetable-urql-provider';
import { ToastProvider } from 'react-toast-notifications';
import { IntlProvider } from 'react-intl';
import ModalPresenter from './components/ui-utils/modal-presenter';
import ToastPresenter from './components/utils/toast-presenter';
import Auth from './logic/redux/auth';
import store, { history } from './logic/redux/store';
import Navigation from './navigation/navigation';
import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import './styles/generated.css';
import './styles/main.css'; // -> during build, postcss generates the file below from main.css, including the tailwindcss classes, now importing for development purposes only
import moment from 'moment';
import 'moment/locale/hu';
import BrowserTabLabel from './navigation/browser-tab-label';
import ScreenWidthObserver from './components/utils/screen-width-observer';
import hu from '../locales/hu.json';
import en from '../locales/en.json';

moment.locale('hu');

// Egymásba ágyazott fordítások átalakítása
function flattenMessages(
  nestedMessages: Record<string, unknown>,
  prefix = '',
): Record<string, string> {
  return Object.keys(nestedMessages).reduce((messages: Record<string, string>, key) => {
    const value = nestedMessages[key];
    const prefixedKey = prefix !== '' ? `${prefix}.${key}` : key;

    if (typeof value === 'string') {
      messages[prefixedKey] = value;
    } else {
      Object.assign(messages, flattenMessages(value as Record<string, unknown>, prefixedKey));
    }

    return messages;
  }, {});
}

/*
dispatch(Auth.actions.doLogout());
*/

const messages = {
  hu: flattenMessages(hu),
  en: flattenMessages(en),
};

const App = (): JSX.Element => {
  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const handleTabClose = (event: Event): boolean => {
      if (store.getState().auth.loggedIn !== undefined && store.getState().auth.loggedIn) {
        console.error('LOGOUT');
        store.dispatch<any>(Auth.actions.doLogout());
      }

      return true;
      //event.preventDefault();

      // eslint-disable-next-line @typescript-eslint/no-explicit-any

      //console.log('beforeunload event triggered');

      //event.returnValue = '';
      //return true;
      //(event.returnValue = 'Are you sure you want to exit?');
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    store.dispatch<any>(Auth.actions.doHandleApplicationStarted());

    window.addEventListener('beforeunload', handleTabClose);

    return () => {
      console.log('App unmounting');
      //store.dispatch<any>(Auth.actions.doLogout());
      window.removeEventListener('beforeunload', handleTabClose);
    };
  }, []);
  const userLanguage = useSelector(Auth.select.selectAuthToken)?.language;
  const loginLanguage = useSelector(Auth.select.selectLanguage)

  const lang = (userLanguage || loginLanguage || 'hu') as 'hu' | 'en' ;

  useEffect(() => {
    moment.locale(lang);
  }, [lang]);
  return (
    <IntlProvider
      locale={userLanguage || loginLanguage || 'hu'}
      defaultLocale={'hu'}
      messages={messages[lang]}
      fallbackOnEmptyString={true}
    >
      <ResetableUrqlProvider>
        <ConnectedRouter history={history}>
          <ToastProvider>
            <Navigation />
            <BrowserTabLabel />
            <ToastPresenter />
            <ModalPresenter />
          </ToastProvider>
        </ConnectedRouter>
      </ResetableUrqlProvider>
      <ScreenWidthObserver />
    </IntlProvider>
  );
};

export default App;
